        // src/components/PeoplePlan/Tables/AssistantManagersTable.js
import React from "react";
import GenericEmployeeTable from "../EmployeeManagement/GenericEmployeeTable";
import { ROLE_CONFIGS } from "../configs/roleConfigs";

function AssistantManagersTable({ selectedMUM, storeData, onNavigateToProfile }) {
  return (
    <GenericEmployeeTable
      selectedMUM={selectedMUM}
      storeData={storeData}
      roleConfig={ROLE_CONFIGS.ASSISTANT_MANAGER}
      onNavigateToProfile={onNavigateToProfile}
      enableSorting={false}
    />
  );
}

export default AssistantManagersTable;